//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InputTag from "../../components/Form/InputTag";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required,
    email = _require.email,
    minLength = _require.minLength,
    maxLength = _require.maxLength,
    helpers = _require.helpers;

export default {
  components: {
    'input-tag': InputTag,
    'v-select': vSelect
  },
  data: function data() {
    return {
      selectData: [{
        label: 'Chocolate',
        value: 'chocolate'
      }, {
        label: 'Vanilla',
        value: 'vanilla'
      }, {
        label: 'Strawberry',
        value: 'strawberry'
      }, {
        label: 'Caramel',
        value: 'caramel'
      }, {
        label: 'Cookies and Cream',
        value: 'cookiescream'
      }, {
        label: 'Peppermint',
        value: 'peppermint'
      }],
      overLineForm: {
        email: "",
        password: "",
        state: "",
        tags: [],
        date: null
      },
      labelsInInput: {
        email: "",
        password: "",
        state: "",
        tags: [],
        date: null
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    overLineForm: {
      email: {
        required: required,
        email: email
      },
      password: {
        required: required,
        maxLength: maxLength(16),
        minLength: minLength(6)
      },
      state: {
        required: required
      },
      tags: {
        required: required,
        minLength: minLength(3)
      },
      date: {
        required: required
      }
    },
    labelsInInput: {
      email: {
        required: required,
        email: email
      },
      password: {
        required: required,
        maxLength: maxLength(16),
        minLength: minLength(6)
      },
      state: {
        required: required
      },
      tags: {
        required: required,
        minLength: minLength(3)
      },
      date: {
        required: required
      }
    }
  },
  methods: {
    onValitadeOverLineFormFormSubmit: function onValitadeOverLineFormFormSubmit() {
      this.$v.overLineForm.$touch();
      console.log("overLineForm is invalid :", this.$v.overLineForm.$invalid);
    },
    onValitadeLabelInInputFormFormSubmit: function onValitadeLabelInInputFormFormSubmit() {
      this.$v.labelsInInput.$touch();
      console.log("labelsInInput is invalid :", this.$v.labelsInInput.$invalid);
    }
  }
};